import { API } from 'src/API'
import { create } from 'zustand'
import { mainMenu } from './menu'
import axios from 'src/API/config'
import { reqError } from 'src/utils'

export const useAuthStore = create((set) => ({
  user: null,

  mainMenu: null,
  activeKeyMainMenu: '',
  setActiveKeyMainMenu: (key) => set({ activeKeyMainMenu: key }),

  setUpUser: () => {
    const user = JSON.parse(window.localStorage.getItem('user'))

    set({ user })
    set({ mainMenu: mainMenu.admin })
  },

  loginUser: async (user) => {
    try {
      const res = await axios.post(API.AUTH.signInEndpoint, user)

      const token = res?.data?.access_token || ''
      window.localStorage.setItem('token', token)
      set({ mainMenu: mainMenu.admin })

      return { success: true }
    } catch (error) {
      return reqError(error)
    }
  },

  refreshUser: async () => {
    try {
      const res = await axios.get(API.COMMON.profileEndpoint)
      const userData = res?.data?.data || null
      window.localStorage.setItem('user', JSON.stringify({ ...userData, role: 'admin' }))
      set({ user: { ...userData, role: 'admin' } })
      return { success: true }
    } catch (error) {
      return reqError(error)
    }
  },

  signUpUser: async (user) => {
    // try {
    //   const res = await axios.post(API.AUTH.signUpEndpoint, user)
    //   const token = res?.data?.data?.access_token || ''
    //   const userData = res?.data?.data?.user || null
    //   window.localStorage.setItem('token', token)
    //   window.localStorage.setItem('user', JSON.stringify(userData))
    //   set({ user: userData })
    //   if (userData?.role === 'admin') {
    //     set({ mainMenu: mainMenu.admin })
    //   }
    //   if (userData?.role === 'provider') {
    //     set({ mainMenu: mainMenu.provider })
    //   }
    //   return { success: true }
    // } catch (error) {
    //   return reqError(error)
    // }
  },

  forgotPassword: async (user) => {
    // try {
    //   const res = await axios.post(API.AUTH.forgotPasswordEndpoint, user)
    //   return {
    //     success: true,
    //     message:
    //       res?.data?.data?.message ||
    //       'We have emailed your password reset link!'
    //   }
    // } catch (error) {
    //   return reqError(error)
    // }
  },

  resetPassword: async (user) => {
    // try {
    //   const res = await axios.post(API.AUTH.resetPasswordEndpoint, user)
    //   return {
    //     success: true,
    //     message: res?.data?.data?.message || 'Success'
    //   }
    // } catch (error) {
    //   return reqError(error)
    // }
  },

  updateProfile: async (data) => {
    // try {
    //   const res = await axios.put(API.AUTH.profileEndpoint, data)
    //   console.log(res)
    //   return {
    //     success: true,
    //     message: res?.data?.data?.message || 'Success'
    //   }
    // } catch (error) {
    //   return reqError(error)
    // }
  },

  logoutUser: () => {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('user')
    set({ user: null })
    set({ mainMenu: null })
    set({ mainMenu: '' })
  }
}))
